import {
  selectMenuListByRoleId,
} from '@/api/MenuManage';
import iconEnumerate from './iconEnumerate';

const getMenuList = ()=>{
  return new Promise((resolve, reject)=>{
    selectMenuListByRoleId({}).then(res=>{
      if(res.data.code == 1004){
        resolve(res.data.data);
      }else{
        resolve([]);
      }
    }).catch(err=>{
      resolve([]);
      console.log(err);
    });
  })
}
const changeMenuList = (data)=>{
  // console.log(state, data);
  const getMenuListFn = (list)=>{
    if(!list){
      return undefined;
    }
    return list.map((menu)=>{
      const item = {
        title: menu.menuName,
        url: menu.menuUrl,
        icon: iconEnumerate[menu.menuName],
        children: getMenuListFn(menu.children),
      }
      return item;
    }).filter((menu)=>{
      return menu.url != '/Home'
    });
  }
  const list = getMenuListFn(data);
  let index = list.findIndex(menu=>{
    return menu.title == '首页';
  });
  if(index == -1 || list.length == 0){
    return list;
  }else{
    let spliceList = list.splice(0, index);
    return list.concat(spliceList)
  }
}
const changeRouteList = (data)=>{
  // console.log(state, data);
  const checkFile = (url)=>{
    let file = require.context(`@/views/`),
        fileList = file.keys();
    if(fileList.includes(`.${url}`) && fileList.includes(`.${url}/index.vue`)){
      return ()=>import(`@/views${url}`);
    }

    return ()=>import(`@/views/Layout`);
  }
  const getRouteItem = (item, flag)=>{
    const defaultCom = item.comType=='system'?()=>import(`@/views/System`):()=>import(`@/views/Layout`);
    const component = flag?defaultCom:checkFile(item.menuUrl),
      returnItem = {
        path: item.entrance?'/':item.menuUrl,
        name: item.menuUrl,
        meta: {
          title: item.menuName,
        },
        component: component,
      };
    // console.log(item, returnItem);
    if(flag){
      returnItem.children = getRoutes(item.children || item, false);
      returnItem.redirect = returnItem.children[0].path;
    }
    return returnItem;
  }
  const getRoutes = (changeData, flag)=>{
    if(changeData.constructor == Array){
      return changeData.map(item=>{
        return getRouteItem(item, flag);
      })
    }else{
      return [
        {
          path: changeData.menuUrl,
          meta: {
            title: changeData.menuName,
          },
          component: checkFile(changeData.menuUrl),
        }
      ]
    }
  }
  return getRoutes(data, true);
}
// name: permissions
const state = {
  routeList: [],
  menuList: [],
  menuIsCollapse: false,
  userCenterURL: '/System',
};
const getters = {
  getRouteList: (state)=>{ return state.routeList; },
  getMenuList: (state)=>{ return state.menuList; },
  getMenuIsCollapse: (state)=>{ return state.menuIsCollapse; },
  getUserCenterURL: (state)=>{ return state.userCenterURL; },
};
const mutations = {
  setUserCenterURL(state, data){
    state.userCenterURL = data;
  },
  menuIsCollapseChange(state, flag){
    state.menuIsCollapse = flag;
  },
  clearMenuList(state){
    state.menuList.splice(0, state.menuList.length);
  },
  clearRouteList(state){
    state.routeList.splice(0, state.routeList.length);
  },
  setMenuList(state, data){
    state.menuList.push(...data);
  },
  setRouteList(state, data){
    state.routeList = data;
  },
};
const actions = {
  menuIsCollapseChange(store, flag){
    store.commit('menuIsCollapseChange', flag);
  },
  initList(store){
    return new Promise(async (resolve, reject)=>{
      const roleName = localStorage.getItem('roleName');
      let data = await getMenuList();
      // let data = await getMenuList(roleName);
      const menuList = changeMenuList(data);
      const routeList = changeRouteList(data);
      for(const menu of menuList || []){
        if(menu.url != '/Home'){
          store.commit('setUserCenterURL', menu.url);
          break;
        }
      }
      // console.log(menuList, routeList);
      store.commit('setMenuList', menuList);
      store.commit('setRouteList', routeList);
      resolve(routeList);
    })
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
